import api from "./axiosInstance";

export const billingApi = {
  // Get monthly billing status for all customers
  getMonthlyStatus: async (month, customerId = null) => {
    try {
      const params = new URLSearchParams();
      if (month) params.append('month', month);
      if (customerId) params.append('customerId', customerId);
      
      const response = await api.get(`billing/monthly-status?${params.toString()}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching monthly billing status:', error);
      throw error;
    }
  },

  // Generate PDF for a single customer using existing API
  generateStatementPdf: async (customerId, fromDate, toDate) => {
    try {
      const params = new URLSearchParams();
      params.append('customerId', customerId);
      if (fromDate) params.append('fromDate', fromDate);
      if (toDate) params.append('toDate', toDate);
      
      const response = await api.get(`challans/statement/pdf?${params.toString()}`, {
        responseType: 'blob'
      });
      return response.data;
    } catch (error) {
      console.error('Error generating statement PDF:', error);
      throw error;
    }
  }
};